import { ParsedUrlQuery } from 'querystring';

import routes from '@/config/routes';

const REDIRECT_TO = {
  creationDetail: 'creation_detail',
  userDetail: 'user_detail',
  creatorDetail: 'creator_detail',
};

export const redirectQueryToRoute = (
  query: ParsedUrlQuery
): string | undefined => {
  /* eslint-disable no-case-declarations */
  switch (query.redirect_to) {
    case REDIRECT_TO.creationDetail:
      const rawCreationId = query.redirect_params_creation_id;
      const creationId =
        typeof rawCreationId === 'string' && parseInt(rawCreationId);
      if (!creationId) return;

      return routes.creationDetail(creationId);
    case REDIRECT_TO.userDetail:
      const userID = query.redirect_params_user_id;
      if (typeof userID !== 'string') return;

      return routes.myPage(userID);
    case REDIRECT_TO.creatorDetail:
      const userName = query.redirect_params_user_name;
      if (typeof userName !== 'string') return;

      return routes.creatorDetail(userName);
    default:
      return undefined;
  }
  /* eslint-enable no-case-declarations */
};

const redirectTargets = {
  creationDetail: (creationId: number): Record<string, string> => ({
    redirect_to: REDIRECT_TO.creationDetail,
    redirect_params_creation_id: `${creationId}`,
  }),
  userDetail: (userId: string): Record<string, string> => ({
    redirect_to: REDIRECT_TO.userDetail,
    redirect_params_user_id: userId,
  }),
  creatorDetail: (userName: string): Record<string, string> => ({
    redirect_to: REDIRECT_TO.creatorDetail,
    redirect_params_user_name: userName,
  }),
};

export default redirectTargets;
